import { useAppTranslation, useBackToShop } from "@/utils";
import { InfoCircleFilled, PhRArrowCounterClockwise } from "@payping/icons";
import { Button, Flex, Typography } from "@payping/web-components";

interface PlanProps {
  errorMessages: { code: string; message: string }[];
  onRetry?: () => void;
}
const PaySetPlanUnAvailable = (props: PlanProps) => {
  const { t } = useAppTranslation();
  const { backToShop, shopName } = useBackToShop();

  return (
    <Flex vertical className="tw:h-full tw:w-full tw:p-4!">
      <Flex flex={1} vertical justify="center" align="center" gap={"large"}>
        <InfoCircleFilled width={80} className="tw:fill-color-warning" />
        <Flex vertical className="tw:w-full" gap={"small"} align="center">
          <Typography.Title level={5} className="tw:m-0!">
            {t("pay.setPlan.unAvailableTitle")}
          </Typography.Title>
          {props.errorMessages.length
            ? props.errorMessages.map((item, index) => (
                <Typography.Paragraph key={index} type="secondary" className="tw:m-0! tw:text-center!">
                  {item.message}
                </Typography.Paragraph>
              ))
            : null}
        </Flex>
        {props.onRetry ? (
          <Button
            icon={<PhRArrowCounterClockwise width={14} height={14} />}
            type="link"
            onClick={() => {
              if (!props.onRetry) return;
              props.onRetry();
            }}
          >
            {t("common.retry")}
          </Button>
        ) : null}
      </Flex>
      <Flex align="center" className="tw:mt-auto tw:w-full" gap={"middle"}>
        <Button
          onClick={() => {
            backToShop();
          }}
          type="primary"
          block
        >
          {shopName ? t("pay.returnTo", { name: shopName }) : t("common.returnToShop")}
        </Button>
      </Flex>
    </Flex>
  );
};

export default PaySetPlanUnAvailable;
